import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { IReduxState } from 'store';

type TDispatch = ThunkDispatch<IReduxState, null, AnyAction>;
export const useThunkDispatch = (): TDispatch => useDispatch<TDispatch>();
